export var EnumAlarmLevel;
(function (EnumAlarmLevel) {
    EnumAlarmLevel[EnumAlarmLevel["AlarmWarning"] = 0] = "AlarmWarning";
    EnumAlarmLevel[EnumAlarmLevel["AlarmMinor"] = 1] = "AlarmMinor";
    EnumAlarmLevel[EnumAlarmLevel["AlarmMajor"] = 2] = "AlarmMajor";
    EnumAlarmLevel[EnumAlarmLevel["AlarmCritical"] = 3] = "AlarmCritical";
})(EnumAlarmLevel || (EnumAlarmLevel = {}));
